import "./TermsOfUse.css";

function TermsOfUse() {

  return (
    <div className="terms-of-use-container">
      <div className="terms-of-use-text-area-outer">
        <div className="terms-of-use-text-area-inner">
          <h1>
            AUSTRALIAN BOND EXCHANGE PTY LTD<br />
            ABE CREDIT ARTIFICIAL INTELLIGENCE TOOL TERMS AND CONDITIONS
          </h1>
          <p>
            These are the terms and conditions that govern the ABE Credit Artificial Intelligence Tool (CAIT) provided by Australian Bond Exchange Pty Ltd ACN 605 038 935 AFSL 484453 (ABE, we, us, our).
          </p>
          <p>
            CAIT provides insight into the credit worthiness of an issuer of a security.
          </p>
          <p>
            Your use of CAIT is governed by these terms and conditions. Please ensure that you read and understand them. By using CAIT and the information offered through CAIT, you are agreeing to these terms and conditions.
          </p>
          <h2>Accuracy of content</h2>
          <p>
            We have taken proper care and precautions to ensure that the information we provide on CAIT is accurate. However, we cannot guarantee, nor do we accept any legal liability arising from or connected to, the accuracy, reliability, currency or completeness of anything contained on CAIT. CAIT is a model and not a predictor of a particular issuer's credit rating.
          </p>
          <p>
            The information contained on CAIT should not take the place of professional advice.
          </p>
          <h2>Use</h2>
          <p>
            You agree that you will use CAIT in accordance with all applicable laws, rules and regulations.
          </p>
          <p>
            You agree that you will not use, nor will you allow or authorise any third party to use, CAIT for any purpose that is unlawful or illegal, defamatory, harassing, abusive, fraudulent or obscene way or in any other inappropriate way.
          </p>
          <p>
            Acting reasonably, we reserve the right to refuse or terminate the provision of CAIT to any person.
          </p>
          <h2>
            Passwords and logins
          </h2>
          <p>
            You must not share your login or password with any person.
          </p>
          <p>
            You are responsible for any unauthorized use of your password and login details, whether carried out by you or by a third party.
          </p>
          <h2>
            Indemnification for loss or damage
          </h2>
          <p>
            By using CAIT, you indemnity us against all or any actions, suits, claims, demands, losses, damages, liabilities, cost and expenses of any nature (including without limitation civil and criminal penalties to the extent permitted by law) suffered or incurred by us and relating to your use of CAIT at any time, actually or contingently.
          </p>
          <h2>
            Intellectual property
          </h2>
          <p>
            We hold all intellectual property rights to CAIT and the content therein, including but not limited to, all layout design, data, graphics, file content, codes, and databases contained on or in connection with CAIT. You must not use, replicate or attempt to replicate the material provided through CAIT other than as permitted by law. Specifically, you must not use or replicate our intellectual property or copyrighted material for commercial purposes unless expressly agreed to by us.
          </p>
          <p>
            If you wish to use content, images or other of our intellectual property, you should submit your request to us at the following email address: <a href="mailto:support@bondexchange.com.au">support@bondexchange.com.au</a>
          </p>
          <h2>
            Limitation of Liability
          </h2>
          <p>
            We take no responsibility for the accuracy of any of the content or statements contained on or generated by CAIT. Statements made are by way of general comment only and you should satisfy yourself as to their accuracy. We are not liable for any damages whatsoever, that you may incur as a result of or relating to your use of CAIT.
          </p>
          <h2>
            Information Collection
          </h2>
          <p>
            Use of information you have provided us with, or that we have collected and retained relating to your use of CAIT, is governed by our Privacy Policy. By using CAIT, you agree to our Privacy Policy. A copy of our Privacy Policy is available on our website - <a href="http://www.bondexchange.com.au">www.bondexchange.com.au</a>.
          </p>
          <h2>
            Governing Law
          </h2>
          <p>
            These terms and conditions are governed by and construed under the law in the State of New South Wales.
          </p>
        </div>
      </div >
    </div >
  );
}

export default TermsOfUse;